module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Saale-Unstrut--2251663e4d7b9b3de0fe06ae67e726a0.jpeg";